module.exports = __webpack_public_path__ + "static/media/1.17_preview.07c1d5ec.png";